import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Row } from 'react-bootstrap';
import { Route } from 'react-router-dom';
import Feed from 'containers/Feed';
import CommunityMessageContainer from 'containers/CommunityMessageContainer';
import ErrorBoundary from 'containers/ErrorBoundary';
import TabView from './TabView';
import './HomePage.css';

class HomePage extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Home Page</title>
        </Helmet>
        <Grid className="main-container">
          <Row className="home-window">
            <div className="col left-panel">
              <ErrorBoundary>
                <Feed location={this.props.location} />
              </ErrorBoundary>
            </div>
            <div className="col right-panel">
              <ErrorBoundary>
                <CommunityMessageContainer />
              </ErrorBoundary>
              <ErrorBoundary>
                <Route exact path="/" component={TabView} />
              </ErrorBoundary>
            </div>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/HomePage/index.js